import{m as a}from"./chunk-HBP5N4FR.js";a();import{MetamaskProvider as e}from"@multiversx/sdk-metamask-provider/out/metamaskProvider";var o=()=>e.isMetamaskInstalled();export{o as a};
//# sourceMappingURL=chunk-B4VDDM7X.js.map
